<template>
  <social-post
    :channels="channels"
    :post="post"
    :editPost="isEditing"
    @send="onSendPost"
    @update="onUpdatePost"
    @delete="onDeletePost"
    @close="onClose"
  ></social-post>
</template>

<script>
import { mapState } from 'vuex';
import SocialPost from '@/components/social/SocialPost';

export default {
  name: 'SocialPostsContainer',

  components: {
    SocialPost,
  },

  props: {
    channels: {
      type: Array,
      default: [],
    },
  },

  computed: {
    ...mapState('social', ['post', 'isEditing']),
  },

  methods: {
    onSendPost(data) {
      this.$store
        .dispatch('social/createSocialPost', data)
        .then(() => this.$emit('close'))
        .then(() => this.$store.dispatch('social/getScheduledMessages'))
        .catch(() => {
          this.$alert('An error occurred');
        });
    },

    onUpdatePost(data) {
      this.$store
        .dispatch('social/updateScheduledPost', data)
        .then(() => this.$emit('close'))
        .then(() => this.$store.dispatch('social/getScheduledMessages'))
        .catch(() => {
          this.$alert('An error occurred');
        });
    },

    onDeletePost(id) {
      this.$store
        .dispatch('social/deleteScheduledPost', id)
        .then(() => this.$emit('close'))
        .catch(() => {
          this.$alert('An error occurred');
        });
    },

    onClose() {
      this.$emit('close');
    },
  },
};
</script>



// WEBPACK FOOTER //
// SocialPostsContainer.vue?6dddef10